import { Observable } from 'rxjs';
import store from '../../index';
import { ofType, StateObservable } from 'redux-observable';
import { debounceTime, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  GetShippingCost,
  GetShippingCostError,
  UpdateMerchProductSample,
  ValidateMerchProductSample,
  ValidateMerchProductSampleSuccess,
  ValidateMerchProductSampleError,
} from '../action-creators';
import { VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER } from '../actions';
import { ProductSample } from '@webapp/store/merch/state';
import { createMerchShippingCostPayload } from '@webapp/store/merch/selectors';
import AppState from '@webapp/store/state';

const validateProductSample = (productSample: ProductSample): boolean => {
  if (!productSample.receiveSample) return false;

  if (
    !productSample.shippingDetails?.name ||
    !productSample.shippingDetails?.country ||
    !productSample.shippingDetails?.region ||
    !productSample.shippingDetails?.city ||
    !productSample.shippingDetails?.postCode ||
    !productSample.shippingDetails?.address
  ) {
    return false;
  }

  return true;
};

export const validateMerchProductSampleOrder = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, ValidateMerchProductSample>(
      VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER
    ),
    debounceTime(500),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const productSample: ProductSample = action.data;

        if (validateProductSample(productSample)) {
          const productId =
            (state.merch.active?.editProduct
              ? state.merch.active?.editProduct.id
              : state.merch.active?.newProduct
              ? state.merch.active?.newProduct?.productId
              : state.merch.active?.product
              ? state.merch.active?.product?.id.toString()
              : '0') || '0';
          const editProduct = state.merch.active?.editProduct;
          const newProduct = state.merch.active?.newProduct;
          const email =
            state.artist.active?.email || state.user.profile?.email || '';

          const phoneNumber =
            state.user.profile?.telephone ||
            state.user.profile?.notVerifiedTelephone ||
            state.artist.active?.telephone;

          const artistId = state.artist.active?.id;
          const shippingCostPayload = createMerchShippingCostPayload(
            productSample,
            productId,
            email,
            phoneNumber,
            editProduct,
            newProduct,
            artistId
          );

          if (shippingCostPayload && shippingCostPayload.products.length > 0) {
            store.dispatch(new ValidateMerchProductSampleSuccess());
            store.dispatch(new GetShippingCost(shippingCostPayload));
          }
        } else {
          store.dispatch(new ValidateMerchProductSampleSuccess());
        }
        return new UpdateMerchProductSample(action.data);
      } catch (err) {
        store.dispatch(
          new ValidateMerchProductSampleError((err as Error).message)
        );
        return new GetShippingCostError((err as Error).message);
      }
    })
  );
